"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNotificationSubscriptionDSK = exports.isEventDependentSubscriptionState = exports.isPostponedSubscriptionState = void 0;
const isPostponedSubscriptionState = (subscriptionState) => {
    const castObject = subscriptionState;
    return castObject.reapplyAfterDateMs !== undefined;
};
exports.isPostponedSubscriptionState = isPostponedSubscriptionState;
const isEventDependentSubscriptionState = (subscriptionState) => {
    const castObject = subscriptionState;
    return castObject.reapplyAfterEvent !== undefined;
};
exports.isEventDependentSubscriptionState = isEventDependentSubscriptionState;
/**
 * DSK is a colon-separated list of:
 * - Entity / Group SK
 * - Incident type
 * - (Optional) Incident subtype
 * - Incident initiator SK
 *
 * If there is no incident subtype, this results in:
 * `entity type or group : ID : incident type : incident initiator type : ID`
 *
 * If there is an incident subtype, this results in:
 * `entity type or group : ID : incident type : ruleset type : ID : incident initiator type : ID`
 *
 * If there is no incident initiator, it the type and ID will be replaced with a single `undefined` instead
 */
const getNotificationSubscriptionDSK = ({ incidentEntityOrGroupingSk, incidentType, incidentSubtype, incidentInitiatorSk, }) => {
    return `${incidentEntityOrGroupingSk}:${incidentType}${incidentSubtype ? `:${incidentSubtype}` : ''}:${incidentInitiatorSk}`;
};
exports.getNotificationSubscriptionDSK = getNotificationSubscriptionDSK;
